/*
 * UserList Messages
 *
 * This contains all the text for the UserList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.RouteEdit.title',
    defaultMessage: 'Edit Route',
  },
  saveButton: {
    id: 'app.containers.RouteEdit.saveButton',
    defaultMessage: 'Save',
  },
  saveSuccess: {
    id: 'app.containers.RouteEdit.saveSuccess',
    defaultMessage: 'Route has been successfully updated.',
  },
  saveFailure: {
    id: 'app.containers.RouteEdit.saveFailure',
    defaultMessage: 'Error. The route could not be updated.',
  },
  deleteButton: {
    id: 'app.containers.RouteEdit.deleteButton',
    defaultMessage: 'Delete',
  },
  deleteSuccess: {
    id: 'app.containers.RouteEdit.deleteSuccess',
    defaultMessage: 'Route has been successfully deleted.',
  },
  deleteFailure: {
    id: 'app.containers.RouteEdit.deleteFailure',
    defaultMessage: 'Error. The route could not be deleted.',
  },
  deleteConfirmTitle: {
    id: 'app.containers.RouteEdit.deleteConfirmTitle',
    defaultMessage: 'Delete Route?',
  },
  deleteConfirmText: {
    id: 'app.containers.RouteEdit.deleteConfirmText',
    defaultMessage: 'Deleting a Route will permanently remove it.',
  },
  deleteConfirmDelete: {
    id: 'app.containers.RouteEdit.deleteConfirmDelete',
    defaultMessage: 'Yes, Delete Route',
  },
  deleteConfirmCancel: {
    id: 'app.containers.RouteEdit.deleteConfirmCancel',
    defaultMessage: 'No, Keep Route',
  },
  disableButton: {
    id: 'app.containers.RouteEdit.disableButton',
    defaultMessage: 'Disable',
  },
  disableSuccess: {
    id: 'app.containers.RouteEdit.disableSuccess',
    defaultMessage: 'Route has been successfully disabled.',
  },
  disableFailure: {
    id: 'app.containers.RouteEdit.disableFailure',
    defaultMessage: 'Error. The route could not be disabled.',
  },
  disableConfirmTitle: {
    id: 'app.containers.RouteEdit.disableConfirmTitle',
    defaultMessage: 'Disable Route?',
  },
  disableConfirmText: {
    id: 'app.containers.RouteEdit.disableConfirmText',
    defaultMessage: 'Disabling a Route will permanently remove it.',
  },
  disableConfirmDelete: {
    id: 'app.containers.RouteEdit.disableConfirmDisable',
    defaultMessage: 'Yes, disable Route',
  },
  disableConfirmCancel: {
    id: 'app.containers.RouteEdit.disableConfirmCancel',
    defaultMessage: 'No, Keep Route',
  },
  enableButton: {
    id: 'app.containers.RouteEdit.enableButton',
    defaultMessage: 'Enable route',
  },
  isDisabled: {
    id: 'app.containers.RouteEdit.isDisabled',
    defaultMessage: 'Route is currently disabled',
  },
  enableSuccess: {
    id: 'app.containers.RouteEdit.enableSuccess',
    defaultMessage: 'Route has been successfully enabled.',
  },
  enableFailure: {
    id: 'app.containers.RouteEdit.enableFailure',
    defaultMessage: 'Error. The route could not be enabled.',
  },
});
